import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_URL from "../../ApiUrl/ApiUrl";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Users = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${API_URL}/users`);
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

 
  return (
    <div>
        <ToastContainer/>
      <div className="content-wrapper pb-2 mb-0">
        <div className="content-header  p-10">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h3 className="m-0 text-dark">User List</h3>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">User List</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table
                    id="userlisttbl"
                    className="table card-table table-vcenter text-nowrap"
                  >
                    <thead>
                      <tr>
                        <th className="w-1">S.No</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user, index) => (
                        <tr key={user._id}>
                          <td>{index + 1}</td>
                          <td>{`${user.firstname} ${user.lastname}`}</td>
                          <td>{user.email}</td>
                          <td>{user.role}</td>
                          <td>
                          {/* <Link className="icon">
                            <i className="fa fa-eye" />
                          </Link> |
                           
                            <Link
                        
                            
                              className="icon text-danger"
                            >
                              <i className="fa fa-trash" />
                            </Link> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
        <nav aria-label="Page navigation example">
          <ul className="pagination mt-4 float-end">
            <li className="page-item">
              <a className="page-link" href="#">
                Previous
              </a>
            </li>
            <li className="page-item">
              <a className="page-link" href="#">
                1
              </a>
            </li>
            <li className="page-item">
              <a className="page-link" href="#">
                2
              </a>
            </li>
            <li className="page-item">
              <a className="page-link" href="#">
                3
              </a>
            </li>
            <li className="page-item">
              <a className="page-link" href="#">
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Users;
